import React from 'react';

export interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ className = '', children, ...props }) => {
  return (
    <div className={`border-b border-[var(--color-gray-200)] px-4 py-3 ${className || ''}`} {...props}>
      {children}
    </div>
  );
};
